'use strict';

var _ = require('lodash');
var Classnames = require('classnames');
var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');
var LinkedStateMixin = require('react-addons-linked-state-mixin');

var Components = require('../../../components');
var Constants = require('../../../constants');
var Forms = require('../../../forms');
var Global = require('../../../global');
var Moma = require('../../../plugins/moma');
var Modal = require('../../../plugins/modal');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./homepage-videos.scss');
}

var ResponsiveMixin    = Global.ResponsiveMixin;

var VideoSegment = React.createClass({
    mixins: [ LinkedStateMixin, ResponsiveMixin ],

    getInitialState: function() {
        return {
            video: null,
            tests: true,
        };
    },
    componentDidMount: function() {
        this.setState({
            captionHeight: jQuery(ReactDOM.findDOMNode(this.refs.test)).height(),
            tests: false
        });
    },
    onModalClose: function() {
        this.refs.gallery.onModalClose();
        this.setState({
            video: null
        });
    },
    render: function() {
        const gallerySpec = {
            desktop: {
                position: 'inside',
                graphic: 'solid',
                navigation: 'hero',
            },
            mobile: {
                position: 'inside',
                graphic: 'simple',
                navigation: 'hero',
            },
        };
        return (
            <div className='hp-gallery'>
                {this.state.tests ? <GalleryCaptionRenderTest gallery={Payload.extra.videoGallery} ref='test' /> : null}

                <div className='hp-gallery-title'>
                    {this.state.viewportLayout == 'desktop' ? 'MODERN OFFICE FURNITURE AND PROJECT VIDEOS'
                                                            : 'PROJECT VIDEOS'}
                </div>
                <div className='hp-gallery-moma'>
                    <VideoGallery ref              = 'gallery'

                                  // Moma parameters:
                                  spec             = {gallerySpec}
                                  padding          = {0}
                                  gallery          = {Payload.extra.videoGallery}
                                  additionalHeight = {this.state.captionHeight}

                                  // VideoGallery parameters:
                                  video            = {this.linkState('video')} />
                </div>
                <VideoModal ref    = 'modal'
                            width  = {1000}
                            height = {600}
                            video  = {this.linkState('video')}
                            onCloseCallback = {this.onModalClose} />
            </div>
        );
    }
});

var GalleryCaption = React.createClass({
    PropTypes: {
        // From VideoSegment Moma.additionalHeight
        height: React.PropTypes.number,

        // From homepage Payload
        slide: React.PropTypes.shape({
            title: React.PropTypes.string,
            subtitle: React.PropTypes.string,
        }),

        // Button callback
        onClick: React.PropTypes.func,
    },
    render: function() {
        var captionStyle = {};
        if (this.props.height) {
            captionStyle.height = this.props.height;
        }
        return (
            <div className='hp-gallery-captions' style={captionStyle}>
                <div className='hp-gallery-captions-container' ref='container'>
                    <div className='hp-gallery-captions-title' style={{marginTop:'-5px'}} dangerouslySetInnerHTML={{__html: this.props.slide.title }} />
                    <div className='hp-gallery-captions-subtitle' dangerouslySetInnerHTML={{__html: this.props.slide.subtitle }} />
                    <Forms.Button label='WATCH' onClick={this.props.onClick} />
                </div>
            </div>
        );
    },
});

// A component that renders all of the gallery captions off-screen to determine the required size
var GalleryCaptionRenderTest = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        return (
            <div className='hp-gallery-renderTest'>
                {this.props.gallery.map((slide, ix) => {
                    return (
                        <div className='hp-gallery-renderTest-container' style={{ width: this.state.viewportWidth }} key={ix}>
                            <GalleryCaption slide={slide} />
                        </div>
                    );
                })}
            </div>
        );
    },
});

var VideoGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            desktop: {
                width: Constants.Breaks.DesktopWidth,
                height: 380,
            },
            mobile: {
                portrait: {
                    width: 500,
                    height: 222,
                },
                landscape: {
                    width: 750,
                    height: 275,
                },
            },
        };
    },
    onModalClose: function() {
        this.startAutoplay(5);
    },
    slideClicked: function(video, ev, id) {
        this.stopAutoplay();
            this.props.video.requestChange(video);  // this prop becoming != null causes VideoModal to render
    },
    slideWillChange: function() {
        if (this.state.ix == 0)
            this.stopAutoplay();
    },
    imageLoaded: function(ev)
    {
        jQuery(ev.currentTarget).closest('.hp-video-container').animate({ opacity: 1 });
    },
    slideContent: function(v) {
        var image
        var ix = v.id - 1
        var size = {width:'1150' , height: '381'}
        if (this.state.viewportLayout == 'desktop') {
            image = 'images/homepage/homepage.slideshow.' + ix + '.jpg'
        } else if (this.state.viewportLayout == 'portrait') {
            image = 'images/homepage/homepage.slideshow.mobile.portrait.' + ix + '.jpg'
            size.width = '436'
            size.width = '194'
        } else if (this.state.viewportLayout == 'landscape') {
            image = 'images/homepage/homepage.slideshow.mobile.landscape.' + ix + '.jpg'
        }
        return (
            <div>
                <div className='hp-gallery-slide'>
                    <picture>
                        <source srcSet={`${Payload.webp}/${image}.webp`} type="image/webp" />
                        <source srcSet={`${Payload.static}/${image}`} type="image/jpg" />
                        <img src={`${Payload.static}/${image}`} onLoad={this.imageLoaded} alt={v.alt} className='hp-gallery-slide' width={size.width} height={size.height} />
                    </picture>
                </div>
                <GalleryCaption slide={v} height={this.props.additionalHeight} onClick={this.slideClicked.bind(this, v)} />
            </div>
        )
    },
})

var VideoModal = React.createClass({
    onClose: function(handler) {
        this.setState({
            video: null,
        });
        this.props.onCloseCallback();
    },
    render: function() {
        if (this.props.video.value != null) {
            const title = this.props.video.value.videoTitle || '';
            const id = this.props.video.value.VimeoID;
            const src = `//player.vimeo.com/video/${id}?autoplay=1&api=1&player_id=${id}`;
            return (
                <Modal onClose={this.onClose} width={this.props.width} height={this.props.height} startOpen={true}>
                    <h2>{title}</h2>
                    <div className='videoplayer'>
                        <iframe ref         = 'iframe'
                                className   = 'homepage-video'
                                id          = {id}
                                src         = {src}
                                frameBorder = {0} allowFullScreen
                                title       = "Vimeo player"
                        >
                        </iframe>
                    </div>
        );
                </Modal>
            );
        }
        else
            return <div />;
    }
});

module.exports = VideoSegment;



// WEBPACK FOOTER //
// ./src/pages/content/homepage/homepage-videos.jsx